import { useTenantConfig } from 'contexts';
import { isServerless } from 'helpers';
import Script from 'next/script';
import React from 'react';
import { useCookieConsentStore } from 'stores';

/**
 * Zalo SDK has no consent API to suppress cookies, so we do NOT load it from `_document` (denied by default on first load).
 * Instead we render the SDK only after the user grants consent.
 * When the flag is off, the SDK keeps loading from `_document` and this component renders nothing.
 */
export const ZaloSdkScript: React.FC = () => {
  const { zaloOAId, epicOmni1936 } = useTenantConfig();
  const isZaloCookiesConsented = useCookieConsentStore((state) =>
    state.functionalityStorage(),
  );

  if (
    !isServerless() ||
    !zaloOAId?.length ||
    !epicOmni1936 ||
    !isZaloCookiesConsented
  ) {
    return null;
  }

  return (
    <Script
      id="zalo-sdk-script"
      strategy="lazyOnload"
      src="https://sp.zalo.me/plugins/sdk.js"
    />
  );
};
